import stringify from "json-stringify-pretty-compact";
import React from "react";
import { useStores } from "../../hooks/use-stores";
import "./document-error.scss";
export const DocumentError = ({ action, document, errorMessage, content }) => {
    const { user, db: { firebase } } = useStores();
    let path;
    try {
        path = document && (firebase === null || firebase === void 0 ? void 0 : firebase.getFullDocumentPath(document, user));
    }
    catch (e) {
        path = "unable to get the document path";
    }
    return (React.createElement("div", { className: "document-error", "data-testid": "document-error" },
        React.createElement("h1", null,
            "Error ",
            action,
            " the document"),
        document ?
            React.createElement("ul", null,
                React.createElement("li", null,
                    "Key: \"",
                    document.key,
                    "\""),
                React.createElement("li", null,
                    "User ID (uid): ",
                    document.uid),
                React.createElement("li", null,
                    "Remote Context: ",
                    document.remoteContext),
                React.createElement("li", null,
                    "Type: \"",
                    document.type,
                    "\""),
                path && React.createElement("li", null,
                    "Path: ",
                    path)) :
            React.createElement("div", null, "Unknown document"),
        errorMessage &&
            React.createElement(React.Fragment, null,
                React.createElement("h2", null, "Error Message"),
                React.createElement("pre", null, errorMessage)),
        content &&
            React.createElement(React.Fragment, null,
                React.createElement("h2", null, "Document Content"),
                React.createElement("pre", null, stringify(content, { maxLength: 150 })))));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9jdW1lbnQtZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9kb2N1bWVudC9kb2N1bWVudC1lcnJvci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxTQUFTLE1BQU0sK0JBQStCLENBQUM7QUFDdEQsT0FBTyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBQzFCLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSx3QkFBd0IsQ0FBQztBQUVuRCxPQUFPLHVCQUF1QixDQUFDO0FBUS9CLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBcUIsQ0FBQyxFQUFFLE1BQU0sRUFBRSxRQUFRLEVBQUUsWUFBWSxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUU7SUFDN0YsTUFBTSxFQUFDLElBQUksRUFBRSxFQUFFLEVBQUUsRUFBQyxRQUFRLEVBQUMsRUFBRSxHQUFHLFNBQVMsRUFBRSxDQUFDO0lBRTVDLElBQUksSUFBSSxDQUFDO0lBQ1QsSUFBSSxDQUFDO1FBQ0gsSUFBSSxHQUFHLFFBQVEsS0FBSSxRQUFRLGFBQVIsUUFBUSx1QkFBUixRQUFRLENBQUUsbUJBQW1CLENBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxDQUFBLENBQUM7SUFDbkUsQ0FBQztJQUFDLE9BQU0sQ0FBQyxFQUFFLENBQUM7UUFDVixJQUFJLEdBQUcsaUNBQWlDLENBQUM7SUFDM0MsQ0FBQztJQUNELE9BQU8sQ0FDTCw2QkFBSyxTQUFTLEVBQUMsZ0JBQWdCLGlCQUFhLGdCQUFnQjtRQUMxRDs7WUFBVyxNQUFNOzRCQUFtQjtRQUNuQyxRQUFRLENBQUMsQ0FBQztZQUNUO2dCQUNFOztvQkFBZ0IsUUFBUSxDQUFDLEdBQUc7eUJBQVk7Z0JBQ3hDOztvQkFBb0IsUUFBUSxDQUFDLEdBQUcsQ0FBTTtnQkFDdEM7O29CQUFxQixRQUFRLENBQUMsYUFBYSxDQUFNO2dCQUNqRDs7b0JBQWlCLFFBQVEsQ0FBQyxJQUFJO3lCQUFZO2dCQUN4QyxJQUFJLElBQUk7O29CQUFXLElBQUksQ0FBTSxDQUM1QixDQUFDLENBQUM7WUFDUCxvREFBMkI7UUFFNUIsWUFBWTtZQUNYO2dCQUNFLGdEQUFzQjtnQkFDdEIsaUNBQU0sWUFBWSxDQUFPLENBQ3hCO1FBRUosT0FBTztZQUNOO2dCQUNFLG1EQUF5QjtnQkFDekIsaUNBQU0sU0FBUyxDQUFDLE9BQU8sRUFBRSxFQUFDLFNBQVMsRUFBRSxHQUFHLEVBQUMsQ0FBQyxDQUFPLENBQ2hELENBRUQsQ0FDUCxDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=